const numberValue = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const amountMatches = (left, right) => Math.abs(left - right) <= 0.02;

export const getInvoiceValidation = (invoice) => {
  const issues = [];
  const items = Array.isArray(invoice?.items) ? invoice.items : [];

  if (!invoice?.supplier_id) issues.push('Поставщик не найден в справочнике');
  const invoiceTotal = numberValue(invoice?.total_amount);
  if (invoiceTotal === null || invoiceTotal < 0) issues.push('Некорректный итог инвойса');
  if (items.length === 0) issues.push('Товарные строки не распознаны');

  let goodsTotal = 0;
  items.forEach((item, index) => {
    const row = index + 1;
    const stems = numberValue(item.total_stems);
    const price = numberValue(item.price_per_stem);
    const lineTotal = numberValue(item.total_line);
    if (!String(item.flower_type || '').trim()) issues.push(`Строка ${row}: не указан вид цветка`);
    if (!String(item.variety || '').trim()) issues.push(`Строка ${row}: не указан сорт`);
    if (stems === null || stems <= 0 || !Number.isInteger(stems)) {
      issues.push(`Строка ${row}: количество стеблей должно быть положительным целым`);
    }
    if (price === null || price < 0) issues.push(`Строка ${row}: некорректная цена`);
    if (lineTotal === null || lineTotal < 0) issues.push(`Строка ${row}: некорректная сумма`);
    if (stems !== null && price !== null && lineTotal !== null && !amountMatches(stems * price, lineTotal)) {
      issues.push(`Строка ${row}: стебли × цена не совпадают с суммой`);
    }
    ['boxes_count', 'bunches_per_box', 'stems_per_bunch'].forEach((field) => {
      const value = numberValue(item[field]);
      if (value !== null && (value < 0 || !Number.isInteger(value))) {
        issues.push(`Строка ${row}: дробное количественное поле`);
      }
    });
    if (/fashion garden/i.test(String(invoice?.supplier_name || ''))) {
      const length = String(item.length || '').trim();
      if (length && !/^\d+(?:[.,]\d+)?(?:\s*CM)?$/i.test(length)) {
        issues.push(`Строка ${row}: значение grade не может использоваться как длина`);
      }
    }
    if (lineTotal !== null) goodsTotal += lineTotal;
  });

  const charges = ['packaging_cost', 'supplier_commission', 'transport_cost']
    .map((field) => numberValue(invoice?.[field]))
    .filter((value) => value !== null)
    .reduce((sum, value) => sum + value, 0);
  if (invoiceTotal !== null && items.length > 0 && !amountMatches(goodsTotal + charges, invoiceTotal)) {
    issues.push('Сумма товаров и начислений не совпадает с итогом инвойса');
  }

  return { valid: issues.length === 0, issues };
};
